import { render, staticRenderFns } from "./ManageDriverTranshipmentListView.vue?vue&type=template&id=05b8dafe"
import script from "./ManageDriverTranshipmentListView.vue?vue&type=script&lang=ts"
export * from "./ManageDriverTranshipmentListView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports